import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=1bcc6778&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"
import style0 from "./DataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bcc6778')) {
      api.createRecord('1bcc6778', component.options)
    } else {
      api.reload('1bcc6778', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=1bcc6778&", function () {
      api.rerender('1bcc6778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataTable.vue"
export default component.exports